import "../css/development.css";
import settings from '../assets/settings.png';
import NoRightClickImage from './Disable';
import { Helmet, HelmetProvider } from 'react-helmet-async';


function Tos() {
    return (
        <HelmetProvider>
            <Helmet title="Terms of Services | Vista Ai">
                <meta name="description" content="Terms of Services page of Vista AI" />
            </Helmet>
            <center>
                <center>
                    <NoRightClickImage src={settings} className="logo" alt="Vite logo" />
                    <div>Under Development</div>
                </center>
            </center>
        </HelmetProvider>
    );
}


export default Tos;
